import React from "react"
import { useZohoFormLogic, ZohoFormFields } from "../zohoForms/zohoLogic"
import { CommonFormProps } from "../../types"
import TextField from "../zohoForms/TextField"
import TextArea from "../zohoForms/TextArea"
import CheckBox from "../zohoForms/CheckBox"
import fetchingGif from "../../assets/images/fetching.gif"

const ZOHO_GET_IN_TOUCH_SUBMIT_URL =
  "https://form.simplity.ai/simplitygroup/form/GETINTOUCH/formperma/bbAeFNXadurN3lTAxNZK8nzyPtQHQIhPLQoYX95hBUE/htmlRecords/submit"

export type GetInTouchFormFields = {
  firstName: string
  lastName: string
  company: string
  email: string
  message: string
  marketing: boolean
}

const zohoGetInTouchFormFields: ZohoFormFields<GetInTouchFormFields> = {
  firstName: {
    zohoFieldName: "SingleLine7",
    initialValue: "",
    required: true,
  },
  lastName: {
    zohoFieldName: "SingleLine8",
    initialValue: "",
    required: true,
  },
  company: {
    zohoFieldName: "SingleLine9",
    initialValue: "",
    required: true,
  },
  email: {
    zohoFieldName: "Email",
    initialValue: "",
    required: true,
    runEmailValidation: true,
  },
  message: {
    zohoFieldName: "MultiLine",
    initialValue: "",
    required: true,
  },
  marketing: {
    zohoFieldName: "DecisionBox",
    initialValue: false,
    required: false,
  },
}

export type GetInTouchFormProps = {
  messageLabel: string
  formSource: string
} & CommonFormProps

const GetInTouchForm = ({
  titleForm,
  firstNameLabel,
  lastNameLabel,
  companyLabel,
  emailLabel,
  messageLabel,
  marketingLabel,
  submitLabel,
  formSource,
  successRedirectUrl,
  requiredFieldErrorMessage,
  validEmailErrorMessage,
  submitErrorMessage,
}: GetInTouchFormProps) => {
  const {
    values,
    errors,
    isFetching,
    submitError,
    setValue,
    clearError,
    doSubmit,
  } = useZohoFormLogic<GetInTouchFormFields>({
    formIdentifier: formSource,
    zohoSubmitUrl: ZOHO_GET_IN_TOUCH_SUBMIT_URL,
    successRedirectUrl: successRedirectUrl,
    requiredFieldValidationMessage: requiredFieldErrorMessage,
    validEmailValidationMessage: validEmailErrorMessage,
    submitErrorMessage: submitErrorMessage,
    zohoFormFields: zohoGetInTouchFormFields,
  })

  return (
    <div className="form__container">
      <h3 className="form__headline">{titleForm}</h3>
      <div className="form__row">
        <TextField
          name="firstName"
          label={firstNameLabel}
          value={values.firstName}
          setValue={setValue}
          error={errors.firstName}
          clearError={clearError}
        />
        <TextField
          name="lastName"
          label={lastNameLabel}
          value={values.lastName}
          setValue={setValue}
          error={errors.lastName}
          clearError={clearError}
        />
      </div>
      <TextField
        name="company"
        label={companyLabel}
        value={values.company}
        setValue={setValue}
        error={errors.company}
        clearError={clearError}
      />
      <TextField
        name="email"
        label={emailLabel}
        value={values.email}
        setValue={setValue}
        error={errors.email}
        clearError={clearError}
      />
      <TextArea
        name="message"
        label={messageLabel}
        value={values.message}
        setValue={setValue}
        error={errors.message}
        clearError={clearError}
        className="mt-n3"
      />
      <div className="form__checkBoxContainer">
        <CheckBox
          name="marketing"
          label={marketingLabel}
          value={values.marketing}
          setValue={setValue}
        />
      </div>
      <div className="form__buttonContainer">
        {isFetching ? (
          <div className="form__fetchingBox">
            <img src={fetchingGif} />
          </div>
        ) : (
          <button onClick={() => doSubmit()} className="form__submit">
            {submitLabel}
          </button>
        )}
        {!!submitError && <p className="form__submit-error">{submitError}</p>}
      </div>
    </div>
  )
}

export default GetInTouchForm
